// extracted by mini-css-extract-plugin
export var activeDot = "_60-c";
export var buttonContainer = "_60-9";
export var channelButton = "_60-a";
export var clickable = "_60-d";
export var content = "_60-0";
export var contentFull = "_60-2";
export var contentThird = "_60-1";
export var contentWrapper = "_60-7";
export var description = "_60-5";
export var heightShort = "_60-f";
export var image = "_60-3";
export var imageContainer = "_60-4";
export var selectButton = "_60-e";
export var spinnerContainer = "_60-b";
export var titleContent = "_60-8";
export var titleWrapper = "_60-6";